module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_5-6f5b19a6f9eb2c7a43dbc8c9434f2e24.jpg";